import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';

import Button from '../../components/Button';
import CartFlyout from '../../components/Cart/flyout';
import PromoCode from '../../components/PromoCode';
import Api, {Utils} from '../../Api';
import LightBox from '../../components/LightBox';
import Processing from '../../components/Processing';
import AddressDisplay from './AddressDisplay';
import PaymentDisplay from './PaymentDisplay';
import AddressEditingModal from './AddressEditingModal';
import PaymentEditingModal from './PaymentEditingModal';

export default class DeliveryDetails extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor() {
    super();

    Utils.bindThis(this, [
      'cartUpdated',
      'userUpdated',
      'instrumentUpdated',
      'setSelectedAddress',
      'setSelectedInstrument',
      'placeOrderInterface',
      'submitOrder',
      'editSelectedAddress',
      'cancel',
      'saveAddress',
      'onDiscount'
    ]);

    this.state = {
      cart: Api.cache.getCart(),
      user: null, // User will be read on componentWillMount().
      selectedAddressToken: null,
      selectedInstrument: Api.cache.getSelectedInstrument(),
      changeAddress: false,
      changePayment: false,
      errorMessage: null
    };
  }

  componentWillMount() {
    Api.cache.addChangeListener(this.cartUpdated, Api.cache.eventTypes.CART_CHANGED);
    Api.cache.addChangeListener(this.userUpdated, Api.cache.eventTypes.USER_CHANGED);
    Api.cache.addChangeListener(this.instrumentUpdated, Api.cache.eventTypes.SELECTED_INSTRUMENT_CHANGED);

    if (!this.state.cart) Api.getCart(true).then(() => { this.cartUpdated();
    });Api.getUser(true).then(() => { this.userUpdated(); });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.cartUpdated, Api.cache.eventTypes.CART_CHANGED);
    Api.cache.removeChangeListener(this.userUpdated, Api.cache.eventTypes.USER_CHANGED);
    Api.cache.removeChangeListener(this.instrumentUpdated, Api.cache.eventTypes.SELECTED_INSTRUMENT_CHANGED);
  }

  cartUpdated() {
    let cart = Api.cache.getCart();
    this.setState({cart});
  }

  userUpdated() {
    let user = Api.cache.getUser();
    let selectedAddressToken = this.state.selectedAddressToken || user.last_shipping_address_token;

    // If we have no addresses, none should be selected.
    if (!user.addresses || user.addresses.length === 0) selectedAddressToken = null;

    if (selectedAddressToken && !user.addresses.find(address => address.token === selectedAddressToken)) selectedAddressToken = null;

    // If we don't have an address selected, select the first.
    if (user.addresses && user.addresses.length > 0 && !selectedAddressToken) selectedAddressToken = user.addresses[0].token;

    let selectedInstrument = this.state.selectedInstrument;
    if (!selectedInstrument && user.instruments.length > 0) {
      selectedInstrument = user.instruments[0].token;
    }

    this.setState({
      user,
      selectedAddressToken,
      selectedInstrument
    });
  }

  instrumentUpdated() {
    let selectedInstrument = Api.cache.getSelectedInstrument();
    if (!selectedInstrument || selectedInstrument === this.state.selectedInstrument) return;
    this.setState({
      selectedInstrument
    });
  }

  placeOrderInterface() {
    // Place order button should be disabled if there is no cart, or the cart is empty, or there are any brands below minimum.
    let buttonDisabled = false;
    let placeOrderText = 'Place Order';

    if (!this.state.user.impersonating) {
      buttonDisabled = !this.state.cart || !this.state.cart.cart
        || this.state.cart.cart.items.length === 0 || this.state.cart.below_minimum.length > 0
        || !this.state.user || !this.state.selectedAddressToken;
    } else {
      placeOrderText = 'Place Order (!)';
    }

    let selectedAddress = null;
    if (this.state.selectedAddressToken && this.state.user && this.state.user.addresses) {
      selectedAddress = this.state.user.addresses.find((address) => {
        return (address.token === this.state.selectedAddressToken);
      });
    }
    selectedAddress = selectedAddress || {};

    let shippingAddressName = selectedAddress.name;
    if (!shippingAddressName && this.state.user) {
      shippingAddressName = this.state.user.name;
    }

    // Instrument
    let instrumentInfo = null;
    if (this.state.user) {
      if (!this.state.selectedInstrument) {
        instrumentInfo = "No payment method selected";
      } else {
        let selectedInstrument = this.state.user.instruments.find((instrument) => {
          return (instrument.token === this.state.selectedInstrument);
        });

        if (!selectedInstrument) {
          instrumentInfo = "Invalid payment information";
        } else if (selectedInstrument.card) {
          instrumentInfo = "Credit card ending in " + selectedInstrument.card.last_four;
        } else {
          instrumentInfo = selectedInstrument.token;
        }
      }
    }

    let addressInfo = "Please, add an address";
    if (this.state.selectedAddressToken) {
      addressInfo =
        <div>
          <div>{shippingAddressName}</div>
          <div>{selectedAddress.address1}</div>
          <div>{selectedAddress.city}, {selectedAddress.state} {selectedAddress.postal_code}</div>
        </div>;
    }

    return (
      <div>
        <h4>Shipping Address</h4>
        <div className="row shipping-address">
          <div className="col-80">
            {addressInfo}
          </div>
          <div className="col-20">
            <a href="#" onClick={
              (event) => {
                event.preventDefault();
                if (this.state.user.addresses.length > 0) {
                  this.setState({changeAddress: true});
                } else {
                  this.editSelectedAddress();
                }
              }}>{ this.state.user.addresses.length === 0 ? 'Add Address' : 'Change' }</a>
          </div>
        </div>
        <div className={ window.linkInstruments ? '' : 'hidden' }>
          <h4>Payment Details</h4>
          <div className="row payment-details">
            <div className="col-80">
              {instrumentInfo}
            </div>
            <div className="col-20">
              <Link to="/checkout/payment">Change</Link>
            </div>
          </div>
        </div>
        <div className="button-row center">
          <Button disabled={buttonDisabled} onClick={this.submitOrder}>{placeOrderText}</Button>
        </div>
      </div>
    );
  }

  setSelectedAddress(addressToken) {
    this.setState({
      selectedAddressToken: addressToken,
      changeAddress: false
    });
  }

  setSelectedInstrument(paymentToken) {
    this.setState({
      selectedInstrument: paymentToken,
      changePayment: false
    });
  }

  editSelectedAddress(addressToken) {
    let selectedAddress = this.state.user.addresses.find((address) => {
      return (address.token === addressToken);
    });
    if (!selectedAddress) {
      selectedAddress = {};
      selectedAddress.name = this.state.user.name;

      let retailer = Api.cache.getRetailer();

      if (retailer && retailer.address && this.state.user.addresses.length === 0) {
        selectedAddress.address1 = retailer.address.address1;
        selectedAddress.address2 = retailer.address.address2;
        selectedAddress.postal_code = retailer.address.postal_code;
        selectedAddress.city = retailer.address.city;
        selectedAddress.state = retailer.address.state;
      }
    }
    this.setState({
      changeAddress: false,
      editAddress: selectedAddress
    });
  }

  translateMessage(failure_reason) {
    // TODO: I don't like it here. There should be created a file/function to handle all message translations.
    switch (failure_reason) {
      case 'CART_IS_EMPTY':
        return 'The cart is empty.';
      case 'BELOW_MINIMUM_BRAND_AMOUNT':
        return 'You have not reached the brand minimum for one or more items on your bag.';
      case 'CLIENT_PRICE_MISMATCH':
        return 'The price of one or more of the products included in the order has changed since the cart was initiated.';
      case 'INVALID_ITEM_UNIT_MULTIPLIER':
        return 'The quantity of one or more of the products included in the order is not a multiple of the item unit multiplier.';
      default:
        // TODO: Send event to server about a missing failure reason.
        return 'Oops! Something went wrong. Please try again!';
    }
  }

  onDiscount(discount) {
    let cart = this.state.cart;
    cart.cart.discount = discount;
    this.setState({cart});
  }

  submitOrder() {
    let promoCode = (this.state.cart.cart && this.state.cart.cart.discount && this.state.cart.cart.discount.code);
    return Api
      .submitOrder(this.state.selectedAddressToken, this.state.selectedInstrument, promoCode)
      .then(
        response => {
          let order = response.orders[0];

          if (order.state === 'FAILED') {
            this.setState({
              errorMessage: this.translateMessage(order.failure_reason)
            });
          } else {
            Api.cache.setCart(null);
            this.context.router.push('/checkout/success');
            return Api.getOrders(false);
          }

          return response;
        }
      )
      .catch(
        (error) => {
          let errorMessage = {
            message: 'User could not send order',
            error: error,
            address_token: this.state.selectedAddressToken,
            instrument_token: this.state.selectedInstrument,
            user: Api.cache.getUser()
          };
          Api.error(JSON.stringify(errorMessage));

          this.setState({
            errorMessage: error.message || 'Something went wrong'
          });
        }
      );
  }

  /* Cancels any other state */
  cancel() {
    this.setState({
      changeAddress: false,
      changePayment: false
    });
  }

  /* Creates/Updates an address */
  saveAddress(address) {
    let currentAddresses = this.state.user.addresses;
    let currentAddressesTokens = currentAddresses.map(address => address.token);
    let returnValue = Api.saveUserAddress(address);

    returnValue.then((response) => {
      let newAddress = this.state.selectedAddressToken;
      response.forEach(responseAddress => {
        if (currentAddressesTokens.indexOf(responseAddress.token) < 0) newAddress = responseAddress.token;
      });
      this.setState({
        changeAddress: false,
        selectedAddressToken: newAddress
      });
    });

    return returnValue;
  }

  render() {
    if (!this.state.user) return null;

    let errorMessage = null;
    if (this.state.errorMessage) {
      errorMessage = <div className="error">{this.state.errorMessage}</div>;
    }

    let selectedAddress = this.state.user.addresses.find(address => address.token === this.state.selectedAddressToken);
    let selectedInstrument = this.state.user.instruments.find(instrument => instrument.token === this.state.selectedInstrument);

    let modalView = null;
    if (this.state.changeAddress) {
      document.body.classList.add('noscroll');

      modalView =
        <LightBox className="address-editing-modal" onClose={this.cancel}>
          <AddressEditingModal
            save={this.saveAddress}
            cancel={this.cancel}
            address={this.state.editAddress}
            addressList={this.state.user.addresses}
            setSelectedAddress={this.setSelectedAddress}
          />
        </LightBox>;
    } else if (this.state.changePayment) {
      document.body.classList.add('noscroll');

      modalView =
        <LightBox className="payment-editing-modal" onClose={this.cancel}>
          <PaymentEditingModal
            save={this.savePayment}
            cancel={this.cancel}
            instrumentList={this.state.user.instruments}
            setSelectedInstrument={this.setSelectedInstrument}
          />
        </LightBox>;

    } else {
      document.body.classList.remove('noscroll');
    }

    return (
      <div className="page-flyout checkout checkout-delivery">
        <h2 className="flyout-header">Checkout</h2>
        <div className="delivery-row">
          <div className="delivery-col">
            <div className="section-header">
              <h3>Shipping Details</h3>
              <div className="edit-link" onClick={() => this.setState({changeAddress: true})}>Edit</div>
            </div>
            <div className="section-contents">
              <AddressDisplay address={selectedAddress}/>
            </div>
            <div className="section-header">
              <h3>Payment Details</h3>
              <div className="edit-link" onClick={() => this.setState({changePayment: true})}>Edit</div>
            </div>
            <div className="section-contents">
              <PaymentDisplay payment={selectedInstrument}/>
            </div>
            <div className="promo-code-section">
              <PromoCode onDiscount={this.onDiscount}/>
            </div>
            {errorMessage}
            <div className="button-container">
              <Button onClick={this.submitOrder} className="full-width" waitingState={<Processing />}>Place Order</Button>
            </div>
          </div>
          <div className="separator-col"/>
          <div className="cart-col">
            <div className="section-header">
              <h3>Order Summary</h3>
              <div className="edit-link" onClick={() => Api.cache.setCartVisible(true)}>Edit</div>
            </div>
            <CartFlyout disableEditing={true} className="cart-inline" cart={this.state.cart} dueToday={true}
                        subtotal={true} textTotal={true}/>
          </div>
        </div>
        {modalView}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/checkout/DeliveryDetails.js
 **/